var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21631 4.27881C4.69854 4.27881 4.27881 4.69854 4.27881 5.21631V6.47754C4.27881 6.7882 4.02697 7.04004 3.71631 7.04004C3.40565 7.04004 3.15381 6.7882 3.15381 6.47754V5.21631C3.15381 4.07722 4.07722 3.15381 5.21631 3.15381H6.47754C6.7882 3.15381 7.04004 3.40565 7.04004 3.71631C7.04004 4.02697 6.7882 4.27881 6.47754 4.27881H5.21631Z",
    fill: "#C1C4CB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21631 19.7212C4.69854 19.7212 4.27881 19.3015 4.27881 18.7837V17.5225C4.27881 17.2118 4.02697 16.96 3.71631 16.96C3.40565 16.96 3.15381 17.2118 3.15381 17.5225V18.7837C3.15381 19.9228 4.07722 20.8462 5.21631 20.8462H6.47754C6.7882 20.8462 7.04004 20.5944 7.04004 20.2837C7.04004 19.973 6.7882 19.7212 6.47754 19.7212H5.21631Z",
    fill: "#C1C4CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7837 4.27881C19.3015 4.27881 19.7212 4.69854 19.7212 5.21631V6.47754C19.7212 6.7882 19.973 7.04004 20.2837 7.04004C20.5944 7.04004 20.8462 6.7882 20.8462 6.47754V5.21631C20.8462 4.07722 19.9228 3.15381 18.7837 3.15381H17.5225C17.2118 3.15381 16.96 3.40565 16.96 3.71631C16.96 4.02697 17.2118 4.27881 17.5225 4.27881H18.7837Z",
    fill: "#C1C4CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7837 19.7212C19.3015 19.7212 19.7212 19.3015 19.7212 18.7837V17.5225C19.7212 17.2118 19.973 16.96 20.2837 16.96C20.5944 16.96 20.8462 17.2118 20.8462 17.5225V18.7837C20.8462 19.9228 19.9228 20.8462 18.7837 20.8462H17.5225C17.2118 20.8462 16.96 20.5944 16.96 20.2837C16.96 19.973 17.2118 19.7212 17.5225 19.7212H18.7837Z",
    fill: "#C1C4CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0225 7.60254H7.97754C7.77043 7.60254 7.60254 7.77043 7.60254 7.97754V16.0225C7.60254 16.2296 7.77043 16.3975 7.97754 16.3975H16.0225C16.2296 16.3975 16.3975 16.2296 16.3975 16.0225V7.97754C16.3975 7.77043 16.2296 7.60254 16.0225 7.60254ZM7.97754 6.47754C7.14911 6.47754 6.47754 7.14911 6.47754 7.97754V16.0225C6.47754 16.8509 7.14911 17.5225 7.97754 17.5225H16.0225C16.8509 17.5225 17.5225 16.8509 17.5225 16.0225V7.97754C17.5225 7.14911 16.8509 6.47754 16.0225 6.47754H7.97754Z",
    fill: "#C1C4CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7826 6.69201C12.9985 6.91535 12.9925 7.27146 12.7692 7.4874L7.54651 12.5371C7.32318 12.753 6.96707 12.747 6.75113 12.5237C6.53519 12.3004 6.54119 11.9442 6.76452 11.7283L11.9872 6.67862C12.2105 6.46268 12.5666 6.46868 12.7826 6.69201Z",
    fill: "#C1C4CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1407 7.13537C17.3566 7.35871 17.3506 7.71481 17.1273 7.93076L7.86554 16.8858C7.64221 17.1017 7.2861 17.0957 7.07016 16.8724C6.85422 16.649 6.86022 16.2929 7.08355 16.077L16.3453 7.12198C16.5686 6.90604 16.9247 6.91204 17.1407 7.13537Z",
    fill: "#C1C4CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.194 11.7418C17.4099 11.9652 17.4039 12.3213 17.1806 12.5372L12.209 17.3441C11.9857 17.56 11.6296 17.554 11.4137 17.3307C11.1977 17.1074 11.2037 16.7513 11.4271 16.5353L16.3986 11.7284C16.6219 11.5125 16.978 11.5185 17.194 11.7418Z",
    fill: "#C1C4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.05664fee9d71a1ca669c75e6525feaf1.svg";
export { ForwardRef as ReactComponent };